var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3496 1L0.499817 20.798",
    stroke: "#606E71"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.702637 1.202L20.5524 21",
    stroke: "#606E71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossThin);
export default __webpack_public_path__ + "static/media/cross-thin.66fa9c8aa7c55f0321c79bc0a769f5cc.svg";
export { ForwardRef as ReactComponent };